export const trackInfo = [
  { name: 'Likes', count: '200K' },
  { name: 'Followers', count: '32K' },
  { name: 'Listened', count: '1.2M' },
];